const SET_FLAG = 'classpass/page/SET_FLAG';
const TOGGLE_FLAG = 'classpass/page/TOGGLE_FLAG';
const USE_DARK_SELL_HEADER = 'classpass/page/USE_DARK_SELL_HEADER';
const USE_REDUCED_NAV = 'classpass/page/USE_REDUCED_NAV';
const USE_REDUCED_FOOTER = 'classpass/page/USE_REDUCED_FOOTER';
const USE_SELL_HEADER = 'classpass/page/USE_SELL_HEADER';
const SET_IS_PRELAUNCH_MODE = 'classpass/page/SET_IS_PRELAUNCH_MODE';
const SET_LOGO_LINK = 'classpass/page/SET_LOGO_LINK';
const SET_PAGE_PROMOTION = 'classpass/page/SET_PAGE_PROMOTION';

export const setFlag = (key, value) => ({ type: SET_FLAG, data: { key, value } });
export const toggleFlag = key => ({ type: TOGGLE_FLAG, data: key });

export const setLogoLink = path => ({ type: SET_LOGO_LINK, data: path });
export const clearLogoLink = setLogoLink.bind(null, null);

export const useDarkSellHeader = (use = true) => ({ type: USE_DARK_SELL_HEADER, data: use });
export const useReducedNavigation = (use = true) => ({ type: USE_REDUCED_NAV, data: use });
export const useReducedFooter = (use = true) => ({ type: USE_REDUCED_FOOTER, data: use });
export const useSellHeader = (use = true) => ({ type: USE_SELL_HEADER, data: use });
export const setPagePromotion = promotion => ({ type: SET_PAGE_PROMOTION, data: promotion });
export const setIsPrelaunchMode = isPrelaunchMode => ({ type: SET_IS_PRELAUNCH_MODE, data: isPrelaunchMode });

export const selectIsPrelaunchMode = state => state.page.isPrelaunchMode;
export const selectPagePromotion = state => state.page.pagePromotion;

export const getInitialState = () => ({
  isPrelaunchMode: false,
  reducedNav: false,
  reducedFooter: false,
  sellHeader: false,
  flags: {
    showCookiePolicy: true,
  },
  logoLink: null,
  pagePromotion: null,
});

export default function reducer(state = getInitialState(), action = {}) {
  switch (action.type) {
    case SET_FLAG:
      return {
        ...state,
        flags: {
          ...state.flags,
          [action.data.key]: action.data.value,
        },
      };
    case TOGGLE_FLAG:
      return {
        ...state,
        flags: {
          ...state.flags,
          [action.data]: !state.flags[action.data],
        },
      };
    case USE_DARK_SELL_HEADER:
      return {
        ...state,
        sellHeader: action.data,
        darkNav: action.data,
      };
    case USE_REDUCED_NAV:
      return {
        ...state,
        reducedNav: action.data,
      };
    case USE_REDUCED_FOOTER:
      return {
        ...state,
        reducedFooter: action.data,
      };
    case USE_SELL_HEADER:
      return {
        ...state,
        sellHeader: action.data,
      };
    case SET_LOGO_LINK:
      return {
        ...state,
        logoLink: action.data,
      };
    case SET_PAGE_PROMOTION:
      return {
        ...state,
        pagePromotion: action.data,
      };
    case SET_IS_PRELAUNCH_MODE:
      return {
        ...state,
        isPrelaunchMode: action.data,
      };
    default:
      return state;
  }
}
